<template>
    <div class="pie">
        <pie-chart :fill="fraction"/>
        <div class="pie__content" ref="content">
            <div>
                <slot/>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import {Component, Prop} from 'vue-property-decorator';
    import PieChart from './PieChart';

    @Component({
        components: {
            PieChart
        }
    })
    export default class PercentagePie extends Vue {
        @Prop({type: Number})
        fraction;
    }
</script>
<style scoped>
    /* TODO Move this style to its own element */
    .pie {
        position: relative;
        width: 200px;
        height: 200px;
    }

    .pie__content {
        position: absolute;
        top: 0;
        left: 0;

        width: 100%;
        height: 100%;

        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/widgets/quick-insights/PercentagePie.vue